import CandyAttackCard from './CandyAttackCard';
import Constants from '../../../constants/Constants';

export default class TripAttackCard extends CandyAttackCard {

    constructor(props) {
        super(props);

        this.cardSound = Constants.SOUND_TRIP_ATTACK_CARD;
        this.cardName = "קלף טיול";
    }
}
